import { useState, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import icon from "../../assets/svg/logo-dashboard-v1.png";
import newNotificationSound from "../../assets/images/new_notification.wav"; // ✅ use existing
import { FiBellOff, FiSpeaker } from "react-icons/fi";

function AudioUnlocker({ onUnlock }) {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        // Test if autoplay is blocked
        const testAudio = new Audio(newNotificationSound);
        testAudio.volume = 0; // silent
        testAudio.play().catch(() => setShowPopup(true));
    }, []);

    const handleUnlock = () => {
        const audio = new Audio(newNotificationSound);
        audio.volume = 0; // play silently once
        audio.play()
            .then(() => {
                console.log("🔊 Audio unlocked");
                setShowPopup(false); // ✅ now popup closes
                onUnlock(true);
            })
            .catch(err => {
                console.error("Still blocked:", err);
                setShowPopup(true); // keep showing if blocked
                onUnlock(false);
            });
    };

    if (!showPopup) return null;

    return (
        <section className="pushnotifca">
            <div className="notify">

                <div className="notify-content">
                    <div className="d-flex align-items-center gap-2">
                        <h4 className="notify-title mb-0 fw-semibold text-dark">
                            Enable Sound
                        </h4>
                        <FiBellOff size={24} className="" />
                    </div>



                    <p className="notify-body">Click here to enable notification sound</p>
                    <button
                        onClick={handleUnlock}
                        className="mt-2 bg-blue-600 text-black text-sm px-3 py-1 rounded-lg hover:bg-blue-700"
                    >
                        Enable
                    </button>
                </div>
                <button
                    className="notify-close"
                    onClick={() => setShowPopup(false)}
                >
                    <IoClose />
                </button>
            </div>
        </section>
    );
}

export default AudioUnlocker;
